import * as i0 from "@angular/core";
export class DetectDeviceService {
    constructor() {
        this.detectDevice();
        this.listenForResize();
    }
    detectDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        this.isMobileDevice = mobileRegex.test(userAgent) || window.innerWidth <= 768;
    }
    listenForResize() {
        window.addEventListener('resize', () => {
            this.detectDevice();
        });
    }
    isMobile() {
        return this.isMobileDevice;
    }
}
DetectDeviceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DetectDeviceService_Factory() { return new DetectDeviceService(); }, token: DetectDeviceService, providedIn: "root" });
